import React, { useEffect, useState } from "react";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";

//Month picket
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/InfoRounded";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import AlertDialog from "../AlertDialog";
import Button from "../Button";
import styles from "./index.module.scss";
import DateRangePicker from "../DateRangePicker";
import { getLocalValue } from "../../utils/auth";
import { downloadCSV } from "../../utils/downloadCSV";
import { apiRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";
import PulseLoader from "react-spinners/PulseLoader";
import { useNotification } from "../../context/notification";
import {
  currentMonth,
  currentYear,
  formattedDateString,
  utcToLocal,
} from "../../utils/datetime";

const XlsxTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #9e9e9e",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
  },
}))(Tooltip);

function ReportDownload({
  dialogOpen,
  setDialogOpen,
  userIp,
  isCoordinator,
  country,
  variant = "standard",
}) {
  const {
    Parser,
    transforms: { unwind },
  } = require("json2csv");

  const { t } = useTranslation();
  const { addNotification } = useNotification();

  const uid = getLocalValue("uid");
  const [value, setValue] = React.useState(null);
  const [radioValue, setRadioValue] = React.useState("");
  const [fileType, setFileType] = React.useState("csv");
  const [dateValue, setDateValue] = React.useState(new Date());
  const [dateRangeValue, setDateRangeValue] = React.useState();
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [canDownload, setCanDownload] = useState(true);
  const [selectOptions, setSelectOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const handleSearchChange = event => {
    setSearchValue(event.target.value);
    let newOptions = options.filter(option =>
      option.label.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setSelectOptions(newOptions);
  };
  const isAllSelected =
    options.length > 0 && selected.length === options.length;
  const useStyles = makeStyles(theme => ({
    formControl: {
      margin: theme.spacing(1),
      width: 300,
    },
    indeterminateColor: {
      color: "#f50057",
    },
    selectAllText: {
      fontWeight: 500,
    },
    selectedAll: {
      "&.Mui-selected": {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
        },
      },
    },
  }));

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 9 + ITEM_PADDING_TOP,
        width: 400,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const classes = useStyles();
  const handleChange = event => {
    setValue(event.target.value);
  };

  useEffect(() => {
    const apiUrl = `/api/getUserCampaignList?uid=${getLocalValue("uid")}`;
    apiRequest
      .get(apiUrl)
      .then(response => {
        if (response.status === 200) {
          let data = response.data.data;
          if (data.length > 0) {
            data = data.map(item => {
              return {
                value: item.campaign_id,
                label: item.sub_functional_unit,
                groupBy: item.functional_unit,
                ...item,
              };
            });

            data = [...data];

            setOptions(data);
            setSelectOptions(data);
          }
        }
      })
      // Fetch data from your API endpoint

      .catch(error => console.error("Error fetching data:", error));
  }, []); // Empty dependency array ensures the effect runs once on component mount

  const handleChanges = event => {
    const value = event.target.value;

    if (value.includes("all")) {
      // If "Select Max 10" is selected, check all options up to 10
      const maxSelectable = Math.min(10, options.length);
      setSelected(prevSelected => {
        const allSelectedValues = options
          .slice(0, maxSelectable)
          .map(option => option.value);
        return prevSelected.length === maxSelectable ? [] : allSelectedValues;
      });
    } else {
      // Remove "all" from selected values, if present
      const updatedSelected = value.filter(val => val !== "all");
      setSelected(updatedSelected);
      // downloadReport(updatedSelected);
    }
  };
  const handleRadioChange = event => {
    setRadioValue(event.target.value);
  };
  useEffect(() => {
    setValue("");
  }, [dialogOpen]);

  // const getCampaign =  async (api) => {
  //   const apiUrl = api
  //     ? `/api/${api}?country_id=${country}`
  //     : `/api/getUserCampaignList?uid=${getLocalValue("uid")}`;

  //   apiRequest
  //     .get(apiUrl)
  //     .then(response => {
  //       console.log(response, 'response checking')
  //       if (response.status === 200) {
  //         const data = response.data.data;
  //         if (!_.isEmpty(data)) {
  //           console.log(data, 'set check')
  //           setCampaignList(data);
  //           if (country) {
  //             setSelectedCampaign(data[0].campaign_id);
  //           } else if (!selectedCampaign) {
  //             setSelectedCampaign(data[0].campaign_id);
  //           }
  //         }

  //       }
  //     })

  // };

  // const getCampaign = async (api) => {
  //   const apiUrl = api
  //     ? `/api/${api}?country_id=${country}`
  //     : `/api/getUserCampaignList?uid=${getLocalValue("uid")}`;

  //   try {
  //     const response = await apiRequest.get(apiUrl);

  //     if (response.status === 200) {
  //       const data = response.data.data;

  //       if (!_.isEmpty(data)) {
  //         setCampaignList(data);

  //         if (country) {
  //           setSelectedCampaign(data[0].campaign_id);
  //         } else if (!selectedCampaign) {
  //           setSelectedCampaign(data[0].campaign_id);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching campaign data:", error);
  //   }
  // };
  const downloadReport = selectedValues => {
    let urlString = "";

    if (value === "coach_coachee_report") {
      urlString = `userId=${uid}`;
      getCoachCoacheeReport(urlString);
    } else {
      //check for null value

      if (radioValue && radioValue !== "") {
        if (radioValue === "monthly" && dateValue) {
          const month = currentMonth(dateValue);
          const year = currentYear(dateValue);
          if (value === "overall_coaching_sessions_report") {
            if (selectedValues && selectedValues.length > 0) {
              urlString = `filter=monthly&userId=${uid}&month=${month}&year=${year}&fileType=${fileType}&selectedValues=${selectedValues.join(
                ","
              )}`;
              getReport(urlString);
            } else {
              setCanDownload(true);
              addNotification(
                `Please select your campaign(s) to download!`,
                "error"
              );
            }
          } else if (value === "session_discussion_report") {
            urlString = `filter=monthly&userId=${uid}&month=${month}&year=${year}`;
            getCoachingDiscussionReport(urlString);
          }
        } else if (radioValue === "custom" && dateRangeValue) {
          if (
            dateRangeValue.startDate &&
            dateRangeValue.startDate !== "" &&
            dateRangeValue.endDate &&
            dateRangeValue.endDate !== ""
          ) {
            if (value === "overall_coaching_sessions_report") {
              if (selectedValues && selectedValues.length > 0) {
                urlString = `filter=custom&userId=${uid}&from='${formattedDateString(
                  utcToLocal(dateRangeValue.startDate)
                )}'&to='${formattedDateString(
                  utcToLocal(dateRangeValue.endDate)
                )}'&fileType=${fileType}&selectedValues=${selectedValues.join(
                  ","
                )}`;
                getReport(urlString);
              } else {
                setCanDownload(true);
                addNotification(
                  `Please select your campaign(s) to download!`,
                  "error"
                );
              }
            } else if (value === "session_discussion_report") {
              urlString = `filter=custom&userId=${uid}&from='${formattedDateString(
                utcToLocal(dateRangeValue.startDate)
              )}'&to='${formattedDateString(
                utcToLocal(dateRangeValue.endDate)
              )}'`;
              getCoachingDiscussionReport(urlString);
            }
          } else {
            setCanDownload(true);
            addNotification(`Please select start and end date!`, "error");
          }
        }
      } else {
        setCanDownload(true);
        addNotification(`Please select your filter Monthly/Custom!`, "error");
      }
    }
  };

  const getReport = urlString => {
    apiRequest
      .get(`/api/getOverallCoachingSessions?${urlString}&userIp=${userIp}`)
      .then(response => {
        setCanDownload(true);
        if (response.status === 200) {
          try {
            setDialogOpen(false);
            addNotification(`${response.data.message}`, "success");
          } catch (err) {
            console.error(err);
            setDialogOpen(false);
            addNotification(`Something went wrong, try again later!`, "error");
          }
        }
      })
      .catch(error => {
        setCanDownload(true);
      });
  };

  const getCoachingDiscussionReport = urlString => {
    apiRequest
      .get(`/api/getCoachingSessionDiscussion?${urlString}&userIp=${userIp}`)
      .then(response => {
        setCanDownload(true);
        if (response.status === 200) {
          let inputJSON = response.data.data.coachingSessionDiscussion;
          inputJSON.forEach((item, index) => {
            if (item.date_of_review) {
              item.date_of_review = utcToLocal(item.date_of_review).format(
                "DD MMM YYYY"
              );
            }
          });
          const fields = [
            "session_id",
            "date_of_review",
            "coach",
            "coachee",
            "casual_notes",
            "casual_notes_given_by",
            "compliments",
            "compliment_given_by",
            "compliment_liked_flag_coach",
            "compliment_liked_flag_coachee",
            "key_points",
            "key_points_given_by",
          ];

          // const transforms = [unwind({ paths: ['session_review', 'session_subjects', 'session_subjects.session_checkpoints'], blankOut: true })];
          try {
            const parser = new Parser({ fields });
            let CSV = parser.parse(inputJSON);

            CSV = CSV.replace("session_id", "Session ID");
            CSV = CSV.replace("date_of_review", "Date Of Review");
            CSV = CSV.replace("coach", "Coach");
            CSV = CSV.replace("coachee", "Coachee");
            CSV = CSV.replace("casual_notes", "Casual Notes");
            CSV = CSV.replace("casual_notes_given_by", "Casual Notes Given By");
            CSV = CSV.replace("compliments", "Compliments");
            CSV = CSV.replace("compliment_given_by", "Compliments Given By");
            CSV = CSV.replace("compliment_given_by", "Compliments Given By");
            CSV = CSV.replace(
              "compliment_liked_flag_coach",
              "Compliments Liked By Coach"
            );
            CSV = CSV.replace(
              "compliment_liked_flag_coachee",
              "Compliments Liked By Coachee"
            );
            CSV = CSV.replace("key_points", "Key Points");
            CSV = CSV.replace("key_points_given_by", "Key Points Given By");

            //CSV string and filename
            downloadCSV(CSV, "Session discussion report");
            setDialogOpen(false);
          } catch (err) {
            console.error(err);
            setDialogOpen(false);
          }
        }
      })
      .catch(error => {
        setCanDownload(true);
      });
  };

  const getCoachCoacheeReport = urlString => {
    apiRequest
      .get(`/api/getCoachCoacheeReport?${urlString}&userIp=${userIp}`)
      .then(response => {
        setCanDownload(true);
        if (response.status === 200) {
          const inputJSON = response.data.data.coachCoacheeList;
          const fields = [
            "coachee_name",
            "coachee_employee_id",
            "coach_name",
            "coach_employee_id",
            "campaign_name",
            "sub_functional_unit_name",
          ];

          // const transforms = [unwind({ paths: ['session_review', 'session_subjects', 'session_subjects.session_checkpoints'], blankOut: true })];
          try {
            const parser = new Parser({ fields });
            let CSV = parser.parse(inputJSON);

            CSV = CSV.replace("coachee_name", "Coachee Name");
            CSV = CSV.replace("coachee_employee_id", "Coachee Employee Id");
            CSV = CSV.replace("coach_name", "Coach Name");
            CSV = CSV.replace("coach_employee_id", "Coach Employee Id");
            CSV = CSV.replace("campaign_name", "Functional Unit");
            CSV = CSV.replace(
              "sub_functional_unit_name",
              "Sub Functional Unit"
            );

            //CSV string and filename
            downloadCSV(CSV, "Coachee report");
            setDialogOpen(false);
          } catch (err) {
            console.error(err);
            setDialogOpen(false);
          }
        }
      })
      .catch(error => {
        setCanDownload(true);
      });
  };

  const stopImmediatePropagation = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <AlertDialog
      open={dialogOpen}
      onClose={() => {
        setDialogOpen(false);
      }}
      body={
        <RadioGroup
          name="radio-buttons-group"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            value="overall_coaching_sessions_report"
            control={<Radio />}
            label={
              <Typography className={styles.formControlLabelBold}>
                {t("dashboard.overallCoachingSessionsReport")}
              </Typography>
            }
          />
          {value === "overall_coaching_sessions_report" && (
            <div className={styles.innerElement} style={{ width: "270px" }}>
              <RadioGroup
                name="radio-buttons-group"
                className={styles.radioGroup}
                size="small"
                value={radioValue}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="monthly"
                  control={<Radio size="small" />}
                  label={
                    <Typography className={styles.formControlLabel}>
                      {t("dashboard.monthly")}
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="custom"
                  control={<Radio size="small" />}
                  label={
                    <Typography className={styles.formControlLabel}>
                      {t("dashboard.custom")}
                    </Typography>
                  }
                />
              </RadioGroup>

              {radioValue === "monthly" && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <CalendarTodayIcon
                    className={styles.calendarIcon}
                    fontSize="16px"
                  />
                  <DatePicker
                    disableToolbar
                    views={["year", "month"]}
                    openTo="year"
                    variant="inline"
                    className={styles.datePicker}
                    value={dateValue}
                    autoOk={true}
                    minDate={new Date("2021-05-01")}
                    disableFuture={true}
                    onChange={setDateValue}
                    renderInput={params => <TextField {...params} />}
                  />
                </MuiPickersUtilsProvider>
              )}
              {radioValue === "custom" && (
                <div style={{ width: "270px" }}>
                  <DateRangePicker
                    handleDateChange={setDateRangeValue}
                    dateSelectionRestriction={false}
                    disableFuture
                  />
                </div>
              )}
            </div>
          )}

          {value === "overall_coaching_sessions_report" && (
            <div
              className={`${styles.innerElement} ${styles.paddingTop}`}
              style={{ width: "270px" }}
            >
              <RadioGroup
                name="radio-buttons-group-filetype"
                className={styles.radioGroup}
                size="small"
                value={fileType}
                onChange={event => setFileType(event.target.value)}
              >
                <FormControlLabel
                  value="csv"
                  control={<Radio size="small" />}
                  label={
                    <Typography className={styles.formControlLabel}>
                      {"CSV"}
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="xlsx"
                  control={<Radio size="small" />}
                  label={
                    <div className={styles.xlsxContainer}>
                      <Typography
                        className={`${styles.formControlLabel} ${styles.xlsxLabel}`}
                      >
                        {"Excel"}
                      </Typography>
                      <XlsxTooltip
                        arrow
                        title={"Support Foreign Language"}
                        placement="right"
                      >
                        <InfoIcon
                          className={styles.infoIcon}
                          fontSize="small"
                        ></InfoIcon>
                      </XlsxTooltip>
                    </div>
                  }
                />
              </RadioGroup>
            </div>
          )}

          {value === "overall_coaching_sessions_report" && (
            <div className={styles.innerElement} style={{ width: "400px" }}>
              <FormControl className={classes.formControl}>
                <div className={styles.row}>
                  <div className={styles.rowLeft}>Campaigns</div>
                  <div className={styles.rowRight}>
                    <Select
                      className={styles.multiselectDropdown}
                      labelId="mutiple-select-label"
                      multiple
                      value={selected}
                      onChange={handleChanges}
                      onClose={() => {
                        setSearchValue("");
                        setSelectOptions(options);
                      }}
                      renderValue={selected => {
                        if (selected.includes("all")) {
                          return "All Functional Unit";
                        }

                        const selectedLabels = selected.map(value => {
                          const selectedOption = options.find(
                            option => option.value === value
                          );
                          return selectedOption ? selectedOption.label : "";
                        });

                        return selectedLabels.join(", ");
                      }}
                      MenuProps={MenuProps}
                    >
                      <MenuItem
                        divider
                        onClickCapture={stopImmediatePropagation}
                        onKeyDown={e => e.stopPropagation()}
                      >
                        <TextField
                          InputProps={{ disableUnderline: true }}
                          placeholder="Search here"
                          style={{ width: "100%" }}
                          value={searchValue}
                          onChange={handleSearchChange}
                        />
                      </MenuItem>
                      <MenuItem
                        value="all"
                        classes={{
                          root: isAllSelected ? classes.selectedAll : "",
                        }}
                        onKeyDown={e => e.stopPropagation()}
                        disabled={selectOptions.length === 0}
                      >
                        <ListItemIcon>
                          <Checkbox
                            classes={{
                              indeterminate: classes.indeterminateColor,
                            }}
                            checked={selected.length === options.length}
                            indeterminate={
                              selected.length > 0 &&
                              selected.length < options.length
                            }
                          />
                        </ListItemIcon>
                        <ListItemText
                          classes={{ primary: classes.selectAllText }}
                          primary="Select max of 10 per download attempt"
                        />
                      </MenuItem>
                      {selectOptions.map(option => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          disabled={
                            selected.length >= 10 &&
                            !selected.includes(option.value)
                          }
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={selected.includes(option.value)}
                            />
                          </ListItemIcon>
                          <ListItemText primary={option.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
              </FormControl>
            </div>
          )}

          <FormControlLabel
            value="session_discussion_report"
            control={<Radio />}
            label={
              <Typography className={styles.formControlLabelBold}>
                {t("dashboard.sessionDiscussionReport")}
              </Typography>
            }
          />
          {value === "session_discussion_report" && (
            <div className={styles.innerElement} style={{ width: "270px" }}>
              <RadioGroup
                name="radio-buttons-group"
                className={styles.radioGroup}
                size="small"
                value={radioValue}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="monthly"
                  control={<Radio size="small" />}
                  label={
                    <Typography className={styles.formControlLabel}>
                      {t("dashboard.monthly")}
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="custom"
                  control={<Radio size="small" />}
                  label={
                    <Typography className={styles.formControlLabel}>
                      {t("dashboard.custom")}
                    </Typography>
                  }
                />
              </RadioGroup>

              {radioValue === "monthly" && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <CalendarTodayIcon
                    className={styles.calendarIcon}
                    fontSize="16px"
                  />
                  <DatePicker
                    disableToolbar
                    views={["year", "month"]}
                    openTo="year"
                    variant="inline"
                    className={styles.datePicker}
                    value={dateValue}
                    autoOk={true}
                    minDate={new Date("2021-05-01")}
                    disableFuture={true}
                    onChange={setDateValue}
                    renderInput={params => <TextField {...params} />}
                  />
                </MuiPickersUtilsProvider>
              )}
              {radioValue === "custom" && (
                <div style={{ width: "270px" }}>
                  <DateRangePicker
                    handleDateChange={setDateRangeValue}
                    dateSelectionRestriction={false}
                    disableFuture
                  />
                </div>
              )}
            </div>
          )}
          <FormControlLabel
            value="coach_coachee_report"
            control={<Radio />}
            label={
              <Typography className={styles.formControlLabelBold}>
                Coach and Coachee Report
              </Typography>
            }
          />
        </RadioGroup>
      }
      footer={
        <>
          <Button size="small" onClick={() => setDialogOpen(false)}>
            {t("dashboard.cancel")}
          </Button>
          <Button
            color="primary"
            size="small"
            onClick={() => {
              setCanDownload(false);
              downloadReport(selected);
            }}
            isdisabled={value && canDownload ? 0 : 1}
          >
            {canDownload ? (
              t("dashboard.download")
            ) : (
              <PulseLoader size={10} color="#9e9e9e" />
            )}
          </Button>
        </>
      }
    />
  );
}

export default ReportDownload;
